import React, { useEffect, useState } from "react";
import BackBG from "../../assets/images/icons/box.svg";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import BestCountry from "./BestCountry";
import CountryVsYou from "./CountryVsYou";
import Leaderbord from "./Leaderbord";
import CoutryIcon from "../../assets/images/icons/ranking/country.svg";
import ActiveCoutryIcon from "../../assets/images/icons/ranking/country-active.svg";
import CoutryUIcon from "../../assets/images/icons/ranking/country-u.svg";
import ActiveCoutryUIcon from "../../assets/images/icons/ranking/country-u-active.svg";
import LeaderbordIcon from "../../assets/images/icons/ranking/leaderbord.svg";
import ActiveLeaderbordIcon from "../../assets/images/icons/ranking/leaderbord-active.svg";
import ActiveButtonBG from "../../assets/images/icons/active-bg.png";
import ButtonBG from "../../assets/images/icons/button-bg.png";

const Tabs = [
  {
    label: "Best Country",
    content: <BestCountry />,
    imgIcons: CoutryIcon,
    iconsActive: ActiveCoutryIcon,
  },
  {
    label: "Country vs You",
    content: <CountryVsYou />,
    imgIcons: CoutryUIcon,
    iconsActive: ActiveCoutryUIcon,
  },
  {
    label: "Leaderboard",
    content: <Leaderbord />,
    imgIcons: LeaderbordIcon,
    iconsActive: ActiveLeaderbordIcon,
  },
];

const GlobalRankings = () => {
  const planName = useSelector((state) =>
    state.user.user?.planName?.toLowerCase()
  );

  const filteredTabs =
    planName === "player"
      ? Tabs.filter((tab) => tab.label !== "Country vs You")
      : Tabs;

  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (activeTab >= filteredTabs.length) {
      setActiveTab(0);
    }
  }, [activeTab, filteredTabs.length]);

  return (
    <>
      <div className="mb-5 flex max-lg:flex-col gap-4 items-center justify-between">
        <Link to="/" className="relative cursor-pointer">
          <div className="max-h-20">
            <img
              src={BackBG}
              alt="Back Background"
              className="w-full h-full max-h-10"
            />
          </div>
          <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 font-semibold text-base">
            Back
          </span>
        </Link>
        <div className="flex max-sm:flex-col gap-4 w-full justify-center">
          {filteredTabs?.map((tab, index) => (
            <React.Fragment key={index}>
              <div
                onClick={() => setActiveTab(index)}
                className="flex items-center justify-center cursor-pointer mx-auto max-w-[350px]"
              >
                <div className="relative z-20">
                  <img
                    src={activeTab === index ? tab.iconsActive : tab.imgIcons}
                    alt="Performance-Icon"
                  />
                </div>
                <div className="relative md:-left-[31px] -left-[28px] z-10">
                  <img
                    src={activeTab === index ? ActiveButtonBG : ButtonBG}
                    alt="Performance-Icon"
                  />
                  <span
                    className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 font-semibold text-lg whitespace-nowrap`}
                  >
                    {tab.label}
                  </span>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
      <div className="w-full">
        <div className="p-4">{filteredTabs[activeTab]?.content}</div>
      </div>
    </>
  );
};

export default GlobalRankings;
